module.exports = __webpack_public_path__ + "img/magento-modules-customization_small.241db9ba.webp";